import { Link } from 'react-router-dom';
import React from 'react';
import {
  FaPhone, FaEnvelope, FaMapMarkerAlt,
  FaFacebook, FaInstagram, FaYoutube,
  FaArrowRight,
  FaTwitter
} from 'react-icons/fa';
import '../../index.css';
import '../../App.css';
import FooterLogo from '../../images/logo/Footer-logo.png'
import RouteConstants from '../../constant/Routeconstant';
import ContactSupportButton from './FeedbackButton';

const Footer = () => {

  const exploreLinks = [
    { label: 'Speakers', path: RouteConstants.SPEAKERLISTSITEILFK },
    { label: 'Photo Gallery', path: RouteConstants.PHOTOGALERYLISTILFK },
    { label: 'Videos', path: RouteConstants.VIDEOSLISTILFK },
    { label: 'News', path: RouteConstants.NEWSLISTILFK },
    { label: 'Sessions', path: RouteConstants.SESSIONSSITEILFK },
  ];

  return (
    
    // <footer className="bg-gray-900 text-gray-300">
    <footer style={{ background: '#111827', color: 'white' }} className='footerContainer'>
      {/* Main Footer */}
      <div className="container mx-auto px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row flex-wrap justify-between gap-y-10 lg:gap-y-0 lg:gap-x-12">

          {/* About Section */}
          <div className="w-full lg:w-[25%] space-y-5">
            <div className="flex items-center">
              <img
                src={FooterLogo}
                alt="ILFK KSA Logo"
                className="h-10 md:h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed">
              The International Literature Festival of Kerala (KSA Edition) brings together global voices to celebrate literature, art, and culture in Thrissur.
            </p>
            <div className="space-y-3">
              <div className="flex items-start">
                <FaMapMarkerAlt className="flex-shrink-0 w-4 h-4 mt-1 text-yellow-400" />
                <span className="ml-3 text-gray-400">Thrissur, Kerala, India</span>
              </div>
              <div className="flex items-center">
                <FaPhone className="w-4 h-4 text-yellow-400 mr-3" />
                <a href="tel:+919876543210" className="text-gray-400 hover:text-white transition-colors">
                  0487-233-1069
                </a>
              </div>
              <div className="flex items-center">
                <FaEnvelope className="w-4 h-4 text-yellow-400 mr-3" />
                <a href="mailto:contact@ilfk.in" className="text-gray-400 hover:text-white transition-colors">
                  ilfk2025@gmail.com
                </a>
              </div> 
               <div className="flex items-center">
                <ContactSupportButton/>
              </div>
            </div>
          </div>

          {/* Optional Spacer */}
          <div className="hidden lg:block w-2"></div>

          {/* Explore Links */}
          <div className="w-full sm:w-1/2 lg:w-[15%]">
            <h3 className="text-lg font-bold text-white mb-6 pb-2 border-b " style={{ borderBottomColor: '#ffffff29' }}>Explore</h3>
            <ul className="space-y-3">
              {exploreLinks.map(({ label, path }) => (
                <li key={label}>
                  <Link
                    to={path}
                    className="text-gray-400 hover:text-yellow-400 transition-colors flex items-center group"
                  >
                    <span className="w-1 h-1 bg-gray-500 rounded-full mr-3 group-hover:bg-yellow-400 transition-colors"></span>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          {/* <div className="w-full sm:w-1/2 lg:w-[15%]">
            <h3 className="text-lg font-bold text-white mb-6 pb-2 border-b" style={{ borderBottomColor: '#ffffff29' }}>Quick Links</h3>
            <ul className="space-y-3">
              {['About ILFK', 'Schedule', 'Venue', 'Partners', 'FAQ'].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-yellow-400 transition-colors flex items-center group"
                  >
                    <span className="w-1 h-1 bg-gray-500 rounded-full mr-3 group-hover:bg-yellow-400 transition-colors"></span>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Newsletter & Social */}
          <div className="w-full lg:w-[25%] space-y-6">

            <div>
              <h4 className="text-lg font-bold text-white mb-6 pb-2 border-b" style={{ borderBottomColor: '#ffffff29' }}>Connect With Us</h4>
              <div className="flex space-x-3">
                {[{ icon: FaFacebook, color: 'bg-blue-600 hover:bg-blue-700', url: 'https://www.facebook.com/ilfk.in/' },
                { icon: FaYoutube, color: 'bg-red-600 hover:bg-red-700', url: 'https://www.youtube.com/@ilfk2024' }
                ].map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-10 h-10 rounded-full flex items-center justify-center text-white transition-colors ${social.color}`}
                  >
                    <social.icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>
           </div>
        </div>

      </div>

      {/* Copyright Section */}
      <div className="border-t border-white" style={{ borderTopColor: '#ffffff2b' }}>
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-500 mb-4 md:mb-0">
              © {new Date().getFullYear()} International Literature Festival of Kerala (KSA Edition). All rights reserved.
            </p>
           <div className="flex flex-wrap justify-center gap-4 md:gap-6">
              {['website developed by solminds.com'].map((item) => (
                
                  <a
                  key={item}
                  href="https://www.solminds.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-500 hover:text-yellow-400 transition-colors"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer >
    
  );
};

export default Footer;
